import { render, staticRenderFns } from "./PushNotificationPermissionPopup.vue?vue&type=template&id=a7534600&scoped=true"
import script from "./PushNotificationPermissionPopup.vue?vue&type=script&lang=js"
export * from "./PushNotificationPermissionPopup.vue?vue&type=script&lang=js"
import style0 from "./PushNotificationPermissionPopup.vue?vue&type=style&index=0&id=a7534600&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7534600",
  null
  
)

export default component.exports